import apiFetch from '../apiFetch'

export default function (values, token) {	
	//Creamos archivo que leerá Magavision ML al iniciarse
	fetch('http://localhost:5690/crear_datos_ml?id=' + values.tokenAnalisisMagavision + '&informe=' + values.isInforme, {method: 'GET', body: null, mode: 'no-cors', credentials: 'omit'})						
	//Abrimos magavision
	window.location.href='appmagavisionmldesktop://magavision'
}
